/**
 * @generated SignedSource<<8ba63120ca457622bf5e34c5bfc14a1f>>
 * @relayHash 781eb670fe145d14fa4a1dc05136b7b9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 623c2d2232ba4b00b3ad6e06d683127f498d69b64b2edd5b4681e32a0e07d3f0

import type { ConcreteRequest } from 'relay-runtime';
export type useTemplateCreatableUpdateInstanceMutation$variables = {
  pageAri: string;
  spaceKey?: string | null;
  templateId?: string | null;
  title?: string | null;
};
export type useTemplateCreatableUpdateInstanceMutation$data = {
  readonly confluence_updateInstance: {
    readonly content: {
      readonly id: string | null;
      readonly links: {
        readonly editui: string | null;
      } | null;
      readonly metadata: {
        readonly simple: {
          readonly isFabric: boolean | null;
        } | null;
      };
      readonly space: {
        readonly key: string | null;
      } | null;
      readonly title: string | null;
      readonly type: string | null;
    } | null;
  } | null;
};
export type useTemplateCreatableUpdateInstanceMutation = {
  response: useTemplateCreatableUpdateInstanceMutation$data;
  variables: useTemplateCreatableUpdateInstanceMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "pageAri"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "spaceKey"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "templateId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "title"
},
v4 = [
  {
    "kind": "Literal",
    "name": "expand",
    "value": "metadata.simple.isFabric,space,version"
  },
  {
    "fields": [
      {
        "fields": [
          {
            "fields": [
              {
                "kind": "Variable",
                "name": "name",
                "variableName": "title"
              },
              {
                "kind": "Variable",
                "name": "spaceKey",
                "variableName": "spaceKey"
              }
            ],
            "kind": "ObjectValue",
            "name": "context"
          },
          {
            "kind": "Variable",
            "name": "templateId",
            "variableName": "templateId"
          }
        ],
        "kind": "ObjectValue",
        "name": "contentBlueprintSpec"
      },
      {
        "kind": "Literal",
        "name": "contentStatus",
        "value": "DRAFT"
      },
      {
        "kind": "Literal",
        "name": "nextVersion",
        "value": 1
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  },
  {
    "kind": "Variable",
    "name": "pageAri",
    "variableName": "pageAri"
  }
],
v5 = {
  "kind": "ScalarField",
  "name": "id"
},
v6 = {
  "kind": "ScalarField",
  "name": "type"
},
v7 = {
  "kind": "ScalarField",
  "name": "title"
},
v8 = {
  "kind": "ScalarField",
  "name": "key"
},
v9 = {
  "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
  "kind": "LinkedField",
  "name": "links",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "editui"
    }
  ]
},
v10 = {
  "concreteType": "ContentMetadata",
  "kind": "LinkedField",
  "name": "metadata",
  "plural": false,
  "selections": [
    {
      "concreteType": "ContentMetadata_SimpleContentMetadataProvider_simple",
      "kind": "LinkedField",
      "name": "simple",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "isFabric"
        }
      ]
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "name": "useTemplateCreatableUpdateInstanceMutation",
    "selections": [
      {
        "args": (v4/*: any*/),
        "concreteType": "ConfluenceUpdateInstancePayload",
        "kind": "LinkedField",
        "name": "confluence_updateInstance",
        "plural": false,
        "selections": [
          {
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              {
                "concreteType": "Space",
                "kind": "LinkedField",
                "name": "space",
                "plural": false,
                "selections": [
                  (v8/*: any*/)
                ]
              },
              (v9/*: any*/),
              (v10/*: any*/)
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "useTemplateCreatableUpdateInstanceMutation",
    "selections": [
      {
        "args": (v4/*: any*/),
        "concreteType": "ConfluenceUpdateInstancePayload",
        "kind": "LinkedField",
        "name": "confluence_updateInstance",
        "plural": false,
        "selections": [
          {
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              {
                "concreteType": "Space",
                "kind": "LinkedField",
                "name": "space",
                "plural": false,
                "selections": [
                  (v8/*: any*/),
                  (v5/*: any*/)
                ]
              },
              (v9/*: any*/),
              (v10/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "781eb670fe145d14fa4a1dc05136b7b9",
    "id": "623c2d2232ba4b00b3ad6e06d683127f498d69b64b2edd5b4681e32a0e07d3f0",
    "metadata": {},
    "name": "useTemplateCreatableUpdateInstanceMutation",
    "operationKind": "mutation",
    "text": "mutation useTemplateCreatableUpdateInstanceMutation($pageAri:ID!,$templateId:String,$title:String,$spaceKey:String){confluence_updateInstance(pageAri:$pageAri,input:{contentBlueprintSpec:{templateId:$templateId,context:{name:$title,spaceKey:$spaceKey}},contentStatus:DRAFT,nextVersion:1},expand:\"metadata.simple.isFabric,space,version\"){content{id,type,title,space{key,id},links{editui},metadata{simple{isFabric}}}}}"
  }
};
})();

(node as any).hash = "8cf4fc4fc1b951143c31cf6f68da5947";

export default node;
